function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-151.6 -161.3)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -59.384 1831)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(621.58 4725.8)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.961-0.96-0.895-2.585-0.895-2.585s1.624-0.066 2.585 0.895c0.96 0.96 0.894 2.584 0.894 2.584s-1.625 0.066-2.584-0.894",
  fill: "#fffbd0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(621.58 4729)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.961-0.96-0.895-2.585-0.895-2.585s1.624-0.066 2.585 0.895c0.96 0.96 0.894 2.584 0.894 2.584s-1.625 0.066-2.584-0.894",
  fill: "#fffbd0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(621.58 4722.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.961-0.961-0.895-2.586-0.895-2.586s1.624-0.065 2.585 0.895c0.96 0.96 0.894 2.584 0.894 2.584s-1.625 0.066-2.584-0.893",
  fill: "#fffbd0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(619.04 4725.7)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.961-0.961 0.895-2.585 0.895-2.585s-1.624-0.066-2.585 0.895c-0.96 0.959-0.894 2.584-0.894 2.584s1.625 0.066 2.584-0.894",
  fill: "#fffbd0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(619.04 4729)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.961-0.961 0.895-2.585 0.895-2.585s-1.624-0.066-2.585 0.895c-0.96 0.959-0.894 2.584-0.894 2.584s1.625 0.066 2.584-0.894",
  fill: "#fffbd0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(619.04 4722.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.961-0.96 0.895-2.585 0.895-2.585s-1.624-0.066-2.585 0.895c-0.96 0.96-0.894 2.584-0.894 2.584s1.625 0.066 2.584-0.894",
  fill: "#fffbd0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(619.12 4730.6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0 1.357 1.195 2.459 1.195 2.459s1.197-1.102 1.196-2.459c1e-3 -1.357-1.196-2.459-1.196-2.459s-1.194 1.102-1.195 2.459",
  fill: "#fffbd0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(599.13 4707)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.262 0.596 1.396 3.13 2.571 5.754l5.656-0.042-2.843-7.161h-4.747c-0.171 0.017-0.571 0.103-0.737 0.366-0.183 0.289-0.046 0.749 0.1 1.083m33.491-1.449h-5.606l-1.318 7.024 6.006-0.045c0.585-1.969 1.19-4.033 1.692-5.765 0.043-0.166 0.113-0.692-0.108-0.976-0.125-0.161-0.343-0.238-0.666-0.238m-7.512 7.028 1.319-7.028h-11.028l1.092 7.093zm-9.2 0.068-1.093-7.096h-9.68l2.841 7.156zm-8.323 0.641-5.627 0.042c1.363 3.042 2.702 6.024 2.728 6.082 0.023 0.065 0.254 0.666 1.303 0.672 0.649 5e-3 2.494 5e-3 4.295 4e-3zm-9.005-8.159c0.276-0.233 0.725-0.401 1.072-0.436 0.03-5e-3 0.058-8e-3 0.088-8e-3l1e-3 3e-3h2e-3v-3e-3h32.877c0.751 0 1.151 0.314 1.355 0.577 0.516 0.672 0.283 1.629 0.254 1.734-0.363 1.251-3.53 12.157-3.999 13.109-0.331 0.671-1.029 0.85-1.388 0.85l-2.784-0.03c-0.24-3e-3 -0.431-0.198-0.428-0.437 2e-3 -0.237 0.195-0.428 0.433-0.428h4e-3l2.78 0.029c8e-3 -1e-3 0.431-0.015 0.605-0.367 0.2-0.406 1.094-3.311 2.078-6.613l-5.942 0.044-1.001 5.339c-0.029 0.158-0.183 0.261-0.337 0.232-0.157-0.03-0.26-0.18-0.231-0.337l0.98-5.229-8.419 0.063 0.81 5.251c0.024 0.157-0.084 0.304-0.241 0.329-0.156 0.02-0.305-0.084-0.33-0.241l-0.822-5.334-7.793 0.057 2.701 6.805c0.635 0 1.243-1e-3 1.772-1e-3l1.767-8e-3c0.24 3e-3 0.431 0.198 0.428 0.437-2e-3 0.237-0.195 0.428-0.432 0.428h-7e-3v6e-3s-7.04 0.01-8.45 0c-1.703-0.01-2.09-1.182-2.106-1.231-0.031-0.064-4.956-11.039-5.54-12.37-0.532-1.21-0.161-1.875 0.243-2.22",
  fill: "#fffbd0"
}))));

var SvgField = function SvgField(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10.782mm",
    height: "8.023mm",
    viewBox: "0 0 12.782 10.023",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgField, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/field.038c1187.svg";
export { ForwardRef as ReactComponent };